export default () => {
    return {
        restrict: 'A',
        link: (scope, element, attr) => {},
        controller: function ($changeUrlHandler) {
            'ngInject';
        }
    };
}